import { createFileRoute } from "@tanstack/react-router";
import { AttendanceFrame } from "@/features/attendance/components/attendance-frame";

// Each tab checks its own module and role in its `beforeLoad`; this route only keeps the frame.
export const Route = createFileRoute("/_authenticated/$slug/attendance")({
  component: AttendanceFrame,
});
